import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Jumbotron extends Component {
  render() {
    return (
      <React.Fragment>
      <Grid container style={{ paddingBottom: '1rem', paddingTop: '1rem' }} justify="center">
        <Grid item xs={10}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img src="./logo-codelab.png" alt="UCL Logo" style={{ maxWidth: '500px', width: '100%', height: '100%' }}/>
          </div>
          <Typography variant="h5" style={{ paddingBottom: '0.5rem', paddingTop: '1rem', fontWeight: '300' }}>
            O <b style={{ fontWeight: '400' }}>USPCodeLab (UCL)</b> é um grupo de extensão universitário que tem por missão <b style={{ fontWeight: '400' }}>estimular a inovação tecnológica na USP</b>.
          </Typography>
          <Typography variant="h5" style={{ paddingBottom: '0.5rem', fontWeight: '300' }}>
            Para tanto, organiza o programa educacional <b style={{ fontWeight: '400' }}>dev.journey()</b>, focado em ajudar seus alunos a se tornarem engenheiros de software.
          </Typography>
          <Typography variant="h5" style={{ paddingBottom: '1rem', fontWeight: '300' }}>
            Para captação, o grupo organiza <b style={{ fontWeight: '400' }}>hackathons e hackdays</b> (em particular o HackathonUSP) envolvendo temas multidisciplinares.
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
    );
  }
}

export default Jumbotron;